import React from "react";
import "./Reasons.css";
import image1 from "../../assets/image1.jpg";
import image2 from "../../assets/image2.jpg";
import image3 from "../../assets/image3.jpg";
import image4 from "../../assets/image4.jpg";
import nb from "../../assets/microsoft.png";
import adidas from "../../assets/google.png";
import nike from "../../assets/linux.png";
import tick from "../../assets/tick.png";
export default function Reasons() {
  return (
    <div className="Reasons" id="reasons">
      <div className="left-r">
        <img src={image1} alt="" />
        <img src={image2} alt="" />
        <img src={image3} alt="" />
        <img src={image4} alt="" />
      </div>
      <div className="right-r">
        <span>Some Reasons</span>
        <div>
          <span className="stroke-text">Why</span>
          <span> choose us?</span>
        </div>
        <div className="details-r">
          <div>
            <img src={tick} alt=""></img>
            <span>over 140+ expert developers</span>
          </div>
          <div>
            <img src={tick} alt=""></img>
            <span>Work smarter and faster than before</span>
          </div>
          <div>
            <img src={tick} alt=""></img>
            <span>1 free service for new client</span>
          </div>
          <div>
            <img src={tick} alt=""></img>
            <span>reliable partners</span>
          </div>
        </div>
        <span style={{ color: "var(--gray)", fontWeight: "normal" }}>
          OUR PARTNERS
        </span>
        <div className="partners">
          <img src={nb} alt="" />
          <img src={adidas} alt="" />
          <img src={nike} alt="" />
        </div>
      </div>
    </div>
  );
}
